import Blazy from 'blazy';
import {
    debouncer,
    randomID
} from "../utils/utils";

/*
* Get the parent ID of the blazy image.
* If no ID is available, create a unique ID
 */
const setBlazySelector = (element) => {
    const id = randomID(10);
    let selector = element.closest('[id]').attr('id');

    if(!selector) {
        element.parent().get(0).id = `b-lazy-${id}`;

        selector = element.closest('[id]').attr('id');
    }

    return selector;
};
const fadeInElement = element => {
    Velocity(element,{
        opacity: 1
    },
    {
        duration: 150,
        complete: () => {
            if(element?.style?.opacity !== '1') {
                element.style.opacity = 1;
            }
        }
    });
};

const initNewBlazy = (config = {}) => {
    const selector = config.parentSelector || '';
    const onSuccess = config.onSuccess || null;

    if($(`${selector} .b-lazy.b-loaded`).length) {
        return;
    }

    const bLazy = new Blazy({
        selector: `${selector} .b-lazy`,
        offset: 300,
        loadInvisible: true,
        success: function (element) {
            setTimeout(() => {
                if (element.parentElement.tagName?.toLowerCase() === 'picture') {
                    element.parentElement.classList.add('lazy-loaded');
                }
            }, 0);
            
            const lazyContainer = $(element).closest('[data-lazy="container"]').get(0);
            const $lazyContainerParent =  $(element).closest('[data-lazy="container"]').parent();
            let scrollTimeOut;

            $lazyContainerParent.scroll(function(){
                clearTimeout(scrollTimeOut);
                scrollTimeOut = setTimeout(() => {
                    bLazy.revalidate();
                }, 100);
            });

            if($(element).hasClass("rb-image")){
                const figureContainer = $(element).closest('.figure-container').get(0);

                if(figureContainer !== null){
                    const type = $(figureContainer).find('span.type').get(0);
                    $(type).addClass('loaded');
                }
            }

            if($(element).closest('.resource-banner-cards').length) {
                const $img = $(element);
                const checkImgOpacity = setInterval(() => {
                    if (+$img.css('opacity') === 1) {
                        clearInterval(checkImgOpacity);

                        $img.closest('.figure-container').children('.type').addClass('loaded');
                    }
                }, 50);
            }

            if (lazyContainer) {
                const lazyContainerLazyChildren = lazyContainer.querySelectorAll('.b-lazy');

                if (lazyContainerLazyChildren) {
                    const bLoadedChildren = Array.from(lazyContainerLazyChildren).filter(children => $(children).hasClass('b-loaded'));

                    if (bLoadedChildren.length >= lazyContainerLazyChildren.length) {
                        fadeInElement(bLoadedChildren);

                        if (+$(lazyContainer).css('opacity') === 0) {
                            $(lazyContainer).velocity({
                                opacity: [1, 0],
                                translateY: [0, -10]
                            },
                            {
                                duration: 300,
                                delay: 300,
                                easing: 'easeOut',
                                queue: false
                            });
                        }
                    }
                }
            } else {
                fadeInElement(element);
            }

            if (onSuccess) {
                onSuccess(element);
            }
        }
    });
};

const replaceImgSrcWithDataSrc = (array) => {
    for(let img of array) {
        const $element = $(img);
        const src = $element.data('src');

        if(!$element.hasClass('b-loaded')) {
            $element
                .css('display', 'none')
                .attr('src', src)
                .css({
                    'opacity' : 1,
                    'display' : 'block'
                })
                .addClass('b-loaded');
        }
    }
};

const initBlazyOnSafari = (config = {}) => {
    const selector = config.selector || '';

    if(browser && browser.name !== 'safari') {
        return;
    }

    switch(selector) {
        case 'header':
            const $mainNav = $('.main-navigation .submenu');
            const $mainNavImg = $mainNav.find('.b-lazy');

            replaceImgSrcWithDataSrc($mainNavImg);
        break;
        case 'footer':
            const $footer = $('footer .column-container');
            const $footerImg = $footer.find('.b-lazy');

            replaceImgSrcWithDataSrc($footerImg);
        break;
    }
};

/*
 * bLazy.js – A lazyload image script
 * http://dinbror.dk/blog/blazy/
 */
const initBlazy = (config) => {
    let blazySelectors = [];

    $('.b-lazy').each(function () {
        if (!$(this).closest('.submenu ').length && !$(this).closest('[data-component-file]').data('vue-component')) {
            let blazyParent = setBlazySelector($(this));

            blazySelectors.push(blazyParent);
        }
    });

    blazySelectors = new Set(blazySelectors);

    if(config.isInitFromVueComponent && config.componentName) {
        $(`[data-vue-component="${config.componentName}"] img`).each(function() {
            const $element = $(this);
            const imageSrc = $element.data('src');

            fadeInElement($element[0]);

            $(this).attr('src', imageSrc).addClass('b-loaded');
        });
    } else {
        if(config.isInitFromVueComponent && !config.componentName) {
            console.warn('lazyload was initialized from a vuejs component but componentName is missing');
        }

        for(let selector of blazySelectors) {
            const blazyParent = `#${selector}`;

            initNewBlazy({
                parentSelector: blazyParent
            });
        }
    }

    initBlazyOnSafari({ selector: 'footer' });

    $('[data-submenu="trigger"]').on('click', function() {
        initNewBlazy({
            parentSelector: '.submenu'
        });

        initBlazyOnSafari({ selector: 'header' });
    });
};

const initLazyLoad = (config = {}) => {
    if ($('.b-lazy').length) {
        initBlazy(config);
    }

    $(window).resize(function () {
        debouncer(initBlazy(config), 150);
        $('.initial-load').removeClass('initial-load');
    });

    $('.initial-load').removeClass('initial-load');
};


export default initLazyLoad;